<button [type]="buttonType" [attr.data-target]="dataTarget" [attr.data-toggle]="dataToggle"
	[attr.aria-expanded]="ariaExpanded" [attr.href]="href" [attr.aria-controls]="ariaControls"
	[attr.aria-haspopup]="ariaHasPopup" [disabled]="disabled" (click)="onClick($event)"
	class="btn {{ cssClass }}">{{ label }}
	<ng-content></ng-content>
</button>